import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { request } from "../../../../request";
import { MainContext } from "../../../../MainContext";

export const IconSelector = ({ account , closeModal}: any) => {
    const [icons, setIcons] = useState<string[]>([]);
    const [selected, setSelected] = useState<string | null>(null);
    const [uploading, setUploading] = useState(false);
    const { updateAccounts } = useContext(MainContext);

    // Load existing icons from backend
    useEffect(() => {
        fetchIcons();
    }, []);

    const fetchIcons = async () => {
        try {
            const res = await request.get("/icon-links"); // <-- should return array of image URLs
            setIcons(res.data);
        } catch (err) {
            console.error("Failed to load icons:", err);
        }
    };

    const handleSelect = (iconUrl: string) => {
        setSelected(iconUrl);
    };

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files?.length) return;

        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("icon", file);

        setUploading(true);
        try {
            const res = await request.post(`/account/edit/${account._id.toString()}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // assuming backend returns uploaded image URL
            fetchIcons();
            updateAccounts();
        } catch (err) {
            console.error("Upload failed:", err);
        } finally {
            setUploading(false);
        }
    };

    const handleIconChange = async () => {
        const formData = new FormData();
        //@ts-ignore
        formData.append("newFileName", selected?.split("/").pop());

        setUploading(true);
        try {
            const res = await request.post(`/account/edit/${account._id.toString()}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            // assuming backend returns uploaded image URL
            fetchIcons();
            updateAccounts();
            closeModal();
        } catch (err) {
            console.error("Upload failed:", err);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-3">Choose or upload an icon</h2>

            {/* Icons grid */}
            <div className="grid grid-cols-6 gap-3 mb-4">
                {icons.map((url) => (
                    <div
                        key={url}
                        onClick={() => handleSelect(url)}
                        className={`w-[50px] h-[50px] rounded-lg border-2 cursor-pointer overflow-hidden flex items-center justify-center
              ${selected === url ? "border-blue-500" : "border-gray-300 hover:border-gray-400"}`}
                    >
                        <img src={url} alt="icon" className="w-full h-full object-cover" />
                    </div>
                ))}
            </div>

            {/* Upload input */}
            <label className="inline-block bg-blue-600 text-white px-4 py-2 rounded-lg cursor-pointer hover:bg-blue-700">
                {uploading ? "Uploading..." : "Upload new icon"}
                <input type="file" accept="image/*" className="hidden" onChange={handleUpload} />
            </label>
            <label onClick={() => handleIconChange()} style={{ marginLeft: "15px" }} className="inline-block bg-green-600 text-white px-4 py-2 rounded-lg cursor-pointer hover:bg-blue-700">
                <button>Save</button>
            </label>

            {selected && (
                <div className="mt-3 text-sm text-gray-600">
                    Selected: <span className="font-medium">{selected}</span>
                </div>
            )}
        </div>
    );
};
